import type CK from '~/types/contentking';

import {
	useAccountCanSignupQuery,
} from './useAccountCanSignup.gql';

import useAccountPropertiesQuery from '~/hooks/useAccountPropertiesQuery';



function useAccountCanSignup(accountId: CK.AccountId | null) {
	const { data } = useAccountPropertiesQuery(
		useAccountCanSignupQuery,
		accountId,
	);

	return data?.account?.canSignup ?? null;
}



export default useAccountCanSignup;
